import React from "react"
import { FullScreenErrorV2 } from "./FullScreenErrorV2"

type Props = {
  children: React.ReactNode
}

type State = {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error) {
    this.setState({ error })
  }

  render() {
    if (this.state.hasError) {
      return (
        <FullScreenErrorV2
          label="Error"
          message={this.state.error?.message || "Something went wrong"}
          buttonLabel="Reset"
          onPress={() => this.setState({ hasError: false, error: undefined })}
        />
      )
    }

    return this.props.children
  }
}
